/**
 * Step 2: Select Level (Countries or Sites)
 *
 * Migrated from: lego/page/etmf/overview/update-study/Step2.jsx
 */

import React from 'react'
import { useServiceContext } from '../../../../root'
import { useDialogContext } from './context/useDialogContext'
import type { FormValues } from './context/DialogContext'

interface Step2Props {
  values: FormValues
  setFieldValue: (field: string, value: any) => void
}

export default function Step2({ values, setFieldValue }: Step2Props) {
  const dialogData = useDialogContext()
  const context = useServiceContext()
  const { translate } = context.service.filter

  return (
    <div className="step">
      <div className="form-group">
        <label className="control-label">
          {values.action === dialogData.actionOptions.add
            ? translate('ETMF_UPDATE_STUDY_STRUCTURE_TITLE_SELECT_ITEMS_TO_ADD')
            : translate('ETMF_UPDATE_STUDY_STRUCTURE_TITLE_SELECT_ITEMS_TO_REMOVE')}
        </label>

        <div className="radio classic mb10 w100p">
          <input
            style={{ margin: '4px 0 0 0' }}
            type="radio"
            name="updateLevel"
            id="countries-level"
            value={dialogData.levelOptions.countries}
            checked={values.level === dialogData.levelOptions.countries}
            onChange={(event) => {
              setFieldValue('level', event.target.value)
            }}
          />
          <label htmlFor="countries-level">
            {values.action === dialogData.actionOptions.add
              ? translate('ETMF_LABEL_COUNTRIES_TO_STUDY')
              : translate('ETMF_LABEL_COUNTRIES_FROM_STUDY')}
          </label>
        </div>

        <div className="radio classic mb10 w100p">
          <input
            style={{ margin: '4px 0 0 0' }}
            type="radio"
            name="updateLevel"
            id="sites-level"
            value={dialogData.levelOptions.sites}
            checked={values.level === dialogData.levelOptions.sites}
            onChange={(event) => {
              setFieldValue('level', event.target.value)
            }}
          />
          <label htmlFor="sites-level">
            {values.action === dialogData.actionOptions.add
              ? translate('ETMF_LABEL_SITES_TO_STUDY')
              : translate('ETMF_LABEL_SITES_FROM_STUDY')}
          </label>
        </div>
      </div>
    </div>
  )
}
